import React from "react";
import {
    Box,
    MenuItem,
    Menu,
    Typography,
    Stack,
    Button,
    Divider,
} from '@mui/material'
import {
    Close as CloseIcon,
    Delete as DeleteIcon,
} from '@mui/icons-material';
import { CustomModal, CustomSnackbar } from '../../../SharedComponents';
import UpdateTransactionModal from './UpdateTransactionModal';

import { deleteTransactionFromService } from 'shared/src/store/transactionSlice';

const successMessage = "La Transacción se ha eliminado correctamente."
const errorMessage = "Ha ocurrido un error, intente más tarde.";

export default function MenuOptions(props){
    const {
        transactionId,
        anchorElForMenuOption,
        handleCloseForMenuOption,
        getTransactionslistFromService,
        userId,
    } = props

    const [actionButtonsDisabled, setActionButtonsDisabled] = React.useState(false);
    const [openDeleteConfirmation, setOpenDeleteConfirmation] = React.useState(false);
    const [openUpdateTransactionModal, setOpenUpdateTransactionModal] = React.useState(false);

    const [opeAlert, setOpenAlert] = React.useState(false);
    const [messageForAlert, setMessageForAlert] = React.useState({});

    // funtions to control delete confirmation
    const handleDeleteTransaction = async _ => {
        setActionButtonsDisabled(true);
        const data = await deleteTransactionFromService(userId, transactionId);
        setActionButtonsDisabled(false);
        if(data){
            getTransactionslistFromService();
            setMessageForAlert({message:successMessage,severity:"success" });
        }else{
            setMessageForAlert({message:errorMessage,severity:"error" });
        }
        setOpenAlert(true);
       setOpenDeleteConfirmation(false);
    }
    const handOpenDeleteConfirmation = () => {
        handleCloseForMenuOption(false)
        setOpenDeleteConfirmation(true);
    }

    const handleChangeStatus = (_) => {
        handleCloseForMenuOption(false)
        setOpenUpdateTransactionModal(true);
    }

    const handleCloseDeleteConfirmation = (_, reason) => {
        if(reason === "backdropClick") return;
        setOpenDeleteConfirmation(false);
    }

    // for small notification
    const handleCloseAlert = (e, reason)=> {
        if (reason === 'clickaway') return;
        setOpenAlert(false);
    }

    return(
        <>
            <Menu
                anchorEl={anchorElForMenuOption}
                open={Boolean(anchorElForMenuOption)}
                onClose={handleCloseForMenuOption}
            >
                <MenuItem onClick={handleChangeStatus}>Cambiar Estado</MenuItem>
                <Divider />
                <MenuItem onClick={handOpenDeleteConfirmation}>Borrar</MenuItem>
            </Menu>
            {/* to confirm delete notifications*/}
            <CustomModal
                handleClose={handleCloseDeleteConfirmation}
                open={openDeleteConfirmation}
                customStyles={{width:'500px'}}
            >
                <Stack>
                    <Typography variant="h7" align="center">Seguro que desea Borrar la Transacción?</Typography>
                    <Box sx={{display:'flex', justifyContent: 'center', mt:2}}>
                        <Button
                            onClick={(e)=>handleDeleteTransaction(e)}
                            disabled={actionButtonsDisabled}
                            startIcon={<DeleteIcon />}
                            variant="contained"
                            color="error"
                            sx={{mr:1}}
                            disableElevation
                        >
                            Borrar
                        </Button>
                        <Button
                            onClick={handleCloseDeleteConfirmation}
                            disabled={actionButtonsDisabled}
                            startIcon={<CloseIcon />}
                            variant="contained"
                            color="success"
                            sx={{ml:1}}
                            disableElevation
                        >
                            Cancelar
                        </Button>
                    </Box>
                </Stack>
            </CustomModal>
            {/*modal to edit transaction status */}
            {openUpdateTransactionModal && <UpdateTransactionModal
                getTransactionslistFromService = {getTransactionslistFromService}
                open={openUpdateTransactionModal}
                setOpen={setOpenUpdateTransactionModal}
                userId={userId}
                transactionId={transactionId}
            />}
            {/* small alert at the bottom left to confirm/deny operation*/}
            <CustomSnackbar opeSnackbar={ opeAlert } messageForAlert={messageForAlert} handleCloseAlert={handleCloseAlert} />
        </>
    );
}